import { tw } from "@careinfo/tailwind";
import React, { useState } from "react";
import TextField from "../../../shared/TextField";
import Combobox from "../../../shared/Combobox";
import CheckBox from "../../../shared/Checkbox";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { INavigation } from "../../../types/interface";
import NavigationForm from "../../Navigation/Form";
import { yupResolver } from "@hookform/resolvers/yup";
import { navigationValidation } from "../../../utils/validationSchema";
import { FormLayout } from "@careinfo/layout";
import Button from "../../../shared/Button";
import useGetHook from "../../../hooks/useGetHook";
import APIS from "../../../constant/Endpoint";
import Spinner from "../../../shared/Spinner";
import { PlusIcon } from "lucide-react";
import Modal from "../../../shared/Modal";
const NavigationPopup = ({ isLoading, handleCreate }) => {
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const createNavigationMethods = useForm<INavigation>({
    resolver: yupResolver(navigationValidation),
  });
  const { data, isLoading: isNavLinksloading } = useGetHook({
    queryKey: ["navigation"],
    url: APIS.NAVIGATION,
    params: {},
  });
  return isNavLinksloading ? (
    <Spinner />
  ) : (
    <>
      <div className={tw`max-w-[500px]  w-full min-h-[300px] mt-6`}>
        {Array.isArray(data) &&
          data?.length > 0 &&
          data?.map((item) => {
            return (
              <div
                key={item?.id}
                className={tw`py-2 px-2 border bg-gray-100 my-1 w-[450px]`}
              >
                <p>{item?.name}</p>
              </div>
            );
          })}
        <button
          type="button"
          onClick={() => setIsOpenPopup(!isOpenPopup)}
          className={tw`focus:outline-none border px-2 py-1 bg-gray-10 flex  items-center gap-x-2 `}
        >
          <PlusIcon /> Add New
        </button>
      </div>
      <Modal title="Link To" isOpen={isOpenPopup} setIsOpen={setIsOpenPopup}>
        <form
          onSubmit={createNavigationMethods.handleSubmit((data) =>
            handleCreate(data, createNavigationMethods.setError, setIsOpenPopup)
          )}
          autoComplete=""
        >
          <FormProvider {...createNavigationMethods}>
            <NavigationForm />
            <div className={tw`w-32 ml-auto mt-4`}>
              <Button label={"Create"} isLoading={isLoading} />
            </div>
          </FormProvider>
        </form>
      </Modal>
    </>
  );
};

export default NavigationPopup;
